import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Callout, PageEmptyState } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import NoDataIcon from '~/integrations/assets/NoDataIcon';
import { IntegrationMappingModal } from '~/integrations/IntegrationMappingModal/IntegrationMappingModal';
import { useStanfordTaxMapServicesModal } from './hooks/useStanfordTaxMapServicesModal';
export const GetStanfordTaxMapServicesModalTID = (parentTestId)=>getTestIds(parentTestId);
export const StanfordTaxMapServicesModal = (param)=>{
    let { testId, dismissModal } = param;
    const { t: stanfordTaxTexts } = useLocaleKeys('integrations.setup.stanfordTax');
    const { t: errorTexts } = useLocaleKeys('errors');
    const { StanfordTaxMapServicesModalTID } = useMemo(()=>GetStanfordTaxMapServicesModalTID(testId), [
        testId
    ]);
    const { rows, contentState, returnTypeSelect, taxYearSelect, isForbidden, forbiddenTooltip, retry, saveRow } = useStanfordTaxMapServicesModal();
    return /*#__PURE__*/ _jsx(IntegrationMappingModal, {
        testId: StanfordTaxMapServicesModalTID.Mapping(),
        title: stanfordTaxTexts.mapServices.title(),
        subheader: stanfordTaxTexts.mapServices.subheader(),
        state: contentState,
        items: rows,
        anchorHeader: stanfordTaxTexts.mapServices.anchorHeader(),
        select: returnTypeSelect,
        secondSelect: taxYearSelect,
        showStatusColumn: false,
        banner: isForbidden && /*#__PURE__*/ _jsx(Callout, {
            intent: "warning",
            testId: StanfordTaxMapServicesModalTID.ForbiddenCallout(),
            children: forbiddenTooltip
        }),
        onMap: saveRow,
        emptyState: /*#__PURE__*/ _jsx(PageEmptyState, {
            testId: StanfordTaxMapServicesModalTID.EmptyState(),
            illustration: /*#__PURE__*/ _jsx(NoDataIcon, {}),
            message: stanfordTaxTexts.mapServices.emptyMessage()
        }),
        onRefresh: retry,
        errorMessage: errorTexts.integration.dataRetrieval(),
        onClose: dismissModal,
        closeBi: {
            name: 'close_stanford_tax_map_services_modal'
        }
    });
};
